"use strict";

var retryQuery = function retryQuery(callback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$maxRetries = _ref.maxRetries,
    maxRetries = _ref$maxRetries === void 0 ? 3 : _ref$maxRetries,
    _ref$retryTime = _ref.retryTime,
    retryTime = _ref$retryTime === void 0 ? 3000 : _ref$retryTime,
    _ref$retryCount = _ref.retryCount,
    retryCount = _ref$retryCount === void 0 ? 0 : _ref$retryCount;
  var tryAgain = function tryAgain(resolve, reject) {
    setTimeout(function () {
      retryQuery(callback, {
        maxRetries: maxRetries,
        retryTime: retryTime,
        retryCount: retryCount + 1
      }).then(resolve)["catch"](reject);
    }, retryTime);
  };
  return new Promise(function (resolve, reject) {
    callback().then(resolve)["catch"](function (e) {
      var response = e.response;
      if (response) {
        var responseCode = response.status;
        if (responseCode && responseCode >= 400 && responseCode < 500) {
          reject(e);
        }
      } else if (retryCount >= maxRetries) {
        reject(e);
      } else {
        tryAgain(resolve, reject);
      }
    });
  });
};
module.exports = retryQuery;